import { BatteryChargingWirelessIcon } from './BatteryChargingWirelessIcon';

/**
 * author: Michael Richins
 * id 60EEA5B6-8070-482D-ABE3-54A9D2A80875
 * name battery-charging-wireless
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/battery-charging-wireless.svg
 * tags
 * - Battery 
 * - Home Automation 
 */
export const BatteryChargingWireless100Icon = BatteryChargingWirelessIcon;
export default BatteryChargingWireless100Icon